import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import ClearCharacterPartsPreviewBody from "./ClearCharacterPartsPreviewBody";

export default function ClearCharacterPartsPreview() {
  return (
    <PiPopupWindowPreview
      header={<PiPopupHeaderBar interactionType={InteractionType.ClearCharacterParts} title="Clear Character Parts" />}
      body={<ClearCharacterPartsPreviewBody />}
      size="large"
    />
  );
}
